import { el } from './dom.js';
import { ZOOM } from '../config.js';

/**
 * 画面右の拡大・縮小スライダー。マウスホイールでも同じ値を動かす。
 * 値は 0（いちばん引き）〜 1（いちばん寄り）。何に効かせるかは onChange 側で決める。
 */
export function createZoomControl(container, { canvas, onChange }) {
  let value = ZOOM.initial;

  const slider = el('input', {
    class: 'zc-slider',
    type: 'range',
    min: '0',
    max: '1',
    step: '0.01',
    value: String(value),
    'aria-label': '拡大・縮小',
  });
  const zoomIn = el('button', { class: 'zc-btn', type: 'button', 'aria-label': '拡大' }, '＋');
  const zoomOut = el('button', { class: 'zc-btn', type: 'button', 'aria-label': '縮小' }, '－');
  const root = el('div', { class: 'zc' }, [zoomIn, slider, zoomOut]);
  container.appendChild(root);

  const set = (next) => {
    value = Math.min(Math.max(next, 0), 1);
    slider.value = String(value);
    onChange(value);
  };

  slider.addEventListener('input', () => set(Number(slider.value)));
  zoomIn.addEventListener('click', () => set(value + ZOOM.wheelStep * 2));
  zoomOut.addEventListener('click', () => set(value - ZOOM.wheelStep * 2));

  // ホイールを奥に回すと寄る。ページ全体がスクロールしないよう既定の動作は止める
  canvas.addEventListener(
    'wheel',
    (event) => {
      event.preventDefault();
      set(value - (event.deltaY / 100) * ZOOM.wheelStep);
    },
    { passive: false },
  );

  onChange(value);
  return {
    get value() {
      return value;
    },
  };
}

/** ズーム値から見回しの視野角(度)を求める */
export function fovFor(value) {
  return ZOOM.fovWide + (ZOOM.fovNarrow - ZOOM.fovWide) * value;
}

/** ズーム値から歩行のカメラ距離の倍率を求める。中央(0.5)で等倍になるよう前後半で分ける */
export function distanceScaleFor(value) {
  if (value <= 0.5) return ZOOM.distanceWide + (1 - ZOOM.distanceWide) * (value / 0.5);
  return 1 + (ZOOM.distanceNarrow - 1) * ((value - 0.5) / 0.5);
}
